'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' });

var TabletAndroid = function TabletAndroid(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

TabletAndroid = (0, _pure2.default)(TabletAndroid);
TabletAndroid.muiName = 'SvgIcon';

exports.default = TabletAndroid;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/TabletAndroid.js
// module id = 2924
// module chunks = 0